import { IDialog } from './IDialog';
import { OnInit, ElementRef, HostListener, Directive } from '@angular/core';
// import { DialogPanelSide } from "./DialogPanelSide";
import $ from "jquery";
const ESCAPE_KEYCODE = 27;

@Directive()
export class DialogFullScreenComponentContent implements IDialog {
    private marginSide: string;
    private targetElement: any;

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.keyCode === ESCAPE_KEYCODE) {
            $('html, body').css('overflow', 'visible');
        }
    }

    constructor(
        protected element: ElementRef,
        protected containerSelector: string = ".modal-fullscreen"
    ) {

    }

    ngOnInit() {

        $(this.element.nativeElement).parents('.cdk-overlay-pane').addClass(this.containerSelector.replace(/\./gi, ''));

        this.targetElement = $(this.element.nativeElement).parents('.mat-dialog-container').parents('.cdk-overlay-pane');
        $(this.element.nativeElement).find(this.containerSelector).show();
        this.targetElement.css({ 'margin-bottom': '-200vh' }).animate({ 'margin-bottom': "0" }, "slow");
        $('html, body').css('overflow', 'hidden');
    }

    close(dialogReference: any, result: any, timeout = 800) {

        $(this.element.nativeElement).find(this.containerSelector).show();
        this.targetElement.css({ 'margin-bottom': '0' }).animate({ 'margin-bottom': '-200vh' }, "slow");
        $('html, body').css('overflow', 'visible');

        //espera a animação de saída
        setTimeout(function () {
            dialogReference.close(result);
        }, timeout);
    }
}